export default __webpack_public_path__ + "static/media/faq.b061f5b3.svg";